module.exports = __webpack_public_path__ + "static/media/robert_zeilinger.e2045ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/robert_zeilinger.png
// module id = 435
// module chunks = 0